export default {
    namespaced: true,

    state: {
        error: null
    },

    mutations: {
        set(state, error) {
            state.error = error;
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/error.js